import { apiConnection } from "@/services/api-connection";

const URL = "";

class ChatbotManager {
  call(message) {
    return apiConnection
      .get(
        URL,
        {
          message: message,
        },
        true,
      )
      .then((response) => response);
  }

  async login() {
    const url = process.env.VUE_APP_CHATBOT_SERVEUR_URL + "/api/login";
    const params = { username: process.env.VUE_APP_CHATBOT_USERNAME, password: process.env.VUE_APP_CHATBOT_PWD };
    const response = await apiConnection.fetchApi("POST", url, params);
    this.storeToken(response.token);
  }

  getToken() {
    return window.sessionStorage.getItem("studea-chatbotToken");
  }

  storeToken(token) {
    const date = new Date();
    date.setMinutes(date.getMinutes() + 59);
    window.sessionStorage.setItem("studea-chatbotTokenExpiration", date.toUTCString());
    window.sessionStorage.setItem("studea-chatbotToken", token);
  }

  isValid() {
    const expiration = window.sessionStorage.getItem("studea-chatbotTokenExpiration");
    const date = new Date();
    return expiration >= date.toUTCString();
  }

  isToken() {
    return !!this.getToken();
  }
}

export const chatBotManager = new ChatbotManager();
